import { CardPropsType } from "./types";
import "./card.scss";

const Card = ({ title, message, icon }: CardPropsType) => {
  return (
    <div className="card-container">
      <div className="icon">{icon}</div>
      <div className="text-container">
        <h3>{title}</h3>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Card;
